const EXTERNAL_NAVIGATION_PROTOCOLS = new Set(['http:', 'https:']);

export const renderEncodedFeatureTemplate = (template: string, properties: Record<string, unknown>) =>
  template.replace(/\{\{\s*([a-zA-Z0-9_.-]+)\s*\}\}/g, (_, key) => {
    const value = properties[key];
    return value == null ? '' : encodeURIComponent(String(value));
  });

export const resolveMapExternalNavigationUrl = (
  template: string | null | undefined,
  properties: Record<string, unknown>,
): string | null => {
  if (!template?.trim()) {
    return null;
  }
  const resolved = renderEncodedFeatureTemplate(template, properties).trim();
  if (!resolved) {
    return null;
  }
  try {
    const url = new URL(resolved);
    if (!EXTERNAL_NAVIGATION_PROTOCOLS.has(url.protocol)) {
      return null;
    }
    return url.toString();
  } catch {
    return null;
  }
};

export const prepareMapExternalNavigationWindow = (): Window | null => {
  if (typeof window === 'undefined' || typeof window.open !== 'function') {
    return null;
  }
  const pendingWindow = window.open('about:blank', '_blank');
  if (!pendingWindow) {
    return null;
  }
  try {
    pendingWindow.opener = null;
  } catch {
    // Ignore browser restrictions when clearing opener on the placeholder tab.
  }
  return pendingWindow;
};

export const openMapExternalNavigationUrl = (url: string, pendingWindow?: Window | null): Window | null => {
  if (pendingWindow && !pendingWindow.closed) {
    pendingWindow.location.replace(url);
    return pendingWindow;
  }
  if (typeof window === 'undefined' || typeof window.open !== 'function') {
    return null;
  }
  return window.open(url, '_blank', 'noopener,noreferrer');
};
